import { z } from 'zod';

export const analytics_toggled = z.object({
  to: z.enum(['granted', 'auto-granted', 'declined']),
}).strict();
